import { ref } from "vue";

/**
 * Module-level so a chip anywhere in the filter bar opens the single host that
 * `FilterBar` renders, rather than each chip carrying its own dialog.
 */
const isOpen = ref(false);

export const useFilterDialog = () => {
	return {
		isFilterDialogOpen: isOpen,
		openFilterDialog: () => {
			isOpen.value = true;
		},
		closeFilterDialog: () => {
			isOpen.value = false;
		},
	};
};
